exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-error[data-v-d87e695a] {\n  font-size: 0.9rem;\n  color: var(--alert);\n}", ""]);

// exports
